/**
 * 在线表单中，新增编辑时供JS增强使用的方法，混入OnlineForm.vue中
 * @author guochao
 * @date 2022/11/1 17:20
 */
import { ACTION_TYPES } from '@comp/online/autoform/model/FieldDefVal'

export default {
  methods: {
    // 获取当前展示子表key
    getSubKey() {
      return this.subTabInfo[ this.subActiveKey ].key
    },
    // 获取子表列表所有数据
    getSubAllData(subKey = this.getSubKey()) {
      if (!subKey) return
      return this.subTableRef(subKey).getAll()
    },
    // 获取主表表单数据
    getMainFormData() {
      return {
        data: this.form.getFieldsValue(),
        form: this.form
      }
    },
    // 子表自定义按钮功能点击回调
    customerButtonClick(data) {
      let buttonCode = data.button.buttonCode
      if (!buttonCode) return this.$message.warning('缺少【buttonCode】参数')
      if (data.button.optType === 'action') return this.subButtonJsHandler(buttonCode)
      if (data.button.optType === 'js') return this.subButtonJsHandler(buttonCode)
      // 导入按钮在上传成功后会回传成功数据
      if (data.detailData) {
        this.subButtonJsHandler(buttonCode, data.detailData)
      }
    },
    /**
     * 设置子表列表工具栏按钮，仅限于操作内置按钮
     * 'add', 'remove', 'clearSelection'
     * @param subKey   子表表名
     * @param excludeArr  不展示按钮数组
     * @author guochao
     * @date 2022/10/20 13:52
     */
    setSubToolsBar(subKey = this.getSubKey(), excludeArr) {
      this.excludeBtn[ subKey ] = excludeArr
    },
    /**
     * 操作子表指定列禁用编辑，不区分行，供JS增强调用
     * @param subKey  子表表名
     * @param isEnabled  是否禁用  true为启用  false为禁用
     * @param fields  要操作的子表列字段code数组
     * @author guochao
     * @date 2022/10/21 10:25
     */
    subColumnEnabled(subKey = this.getSubKey(), fields, isEnabled) {
      let subObj = this.subTabInfo.find(ele => ele.key === subKey)
      if (!subObj || !subObj.columns) return
      subObj.columns.map(item => item.enabled = fields.includes(item.key)? isEnabled: !isEnabled)
      this.subKey++
    },
    /**
     * 根据行设置子表字段启用禁用，供JS增强调用
     * @param subRef  子表列表组件
     * @param fields  字段数组
     * @param disabled  true 禁用  false 启用
     * @param index  操作行的index
     * @author guochao
     * @date 2022/11/1 11:39
     */
    subRowFieldEnabled(subRef, { fields, index, disabled }) {
      subRef.setFieldDisabledByRow({ fields, index, disabled })
    },
    /**
     * 操作子表列表表头显示隐藏，供JS增强方法中调用
     * @param subKey  子表表名
     * @param fields  要操作的子表列字段code数组
     * @param isShow  隐藏/展示字段 true/false
     * @author guochao
     * @date 2022/10/24 09:42:39
     * */
    subColumnShow(subKey = this.getSubKey(), fields, isShow) {
      // 由于jvxeTable使用render函数写的组件，导致会多次重新渲染列表，所以无法使用下面这种方法
      let subObj = this.subTabInfo.find(ele => ele.key === subKey)
      let index = this.subTabInfo.findIndex(ele => ele.key === subKey)
      if (!subObj || !subObj.columns) return
      let arr = subObj.columns.map(item => {
        let visible = fields.includes(item.key)? isShow: !isShow
        return {
          ...item,
          visible
        }
      })
      this.subTabInfo[index] = {
        ...subObj,
        columns: arr
      }
    },
    /**
     * 主表值改变，设置子表中自定义接口获取固定下拉框数据，多行数据一致
     * @param index 要设置的行号
     * @param field   要设置的字段
     * @author guochao
     * @date 2022/9/21 14:26
     */
    setSubFixedOptions({ field, subKey = this.getSubKey(), data = [] }) {
      if (!field || !subKey || !data) {
        return this.$message.warning('【setSubFixedOptions】方法缺少必要参数')
      }
      let subArr = []
      this.subTabInfo.forEach(ele => {
        if (ele.key === subKey) {
          let arr = []
          ele.columns.forEach(item => {
            let dataItem = { ...item }
            if (dataItem.key === field) {
              dataItem.options = data
            }
            arr.push(dataItem)
          })
          ele.columns = arr
        }
        subArr.push(ele)
      })
      this.subTabInfo = subArr
    },
    /**
     * 子表值改变，设置子表中自定义接口获取固定下拉框数据，每行下拉框数据不一致情况
     * @param subKey  子表表名
     * @param data  要设置的下拉框数据
     * @param index 要设置的行号
     * @param field   要设置的字段
     * @author guochao
     * @date 2022/9/21 14:26
     */
    setSubLinkageOptions({ field, subKey = this.getSubKey(), data = [], index }) {
      if (!field || !subKey || !data) {
        return this.$message.warning('【setSubLinkageOptions】方法缺少必要参数')
      }
      let optionsArr = data
      !data.length && (optionsArr = [{
        label: '请选择',
        value: undefined
      }])
      this.subTableRef(subKey).setOptionDataObj({ field, data: optionsArr, index })
    },
    // 更新主表联动类型表单项的option
    reloadLinkDownWidget() {
      let data = this.form.getFieldsValue()
      this.$bus.$emit('formInitDataSuccess', data)
    },
    /**
     * 给子表列表动态添加表头
     * @param subKey  子表表名
     * @param columns  要添加的表头
     * @param sortField  添加的位置在哪个字段之前
     * @author guochao
     * @date 2022/9/29 14:00
     */
    addSubColumn(subKey = this.getSubKey(), columns, sortField) {
      this.subTabInfo.forEach(ele => {
        if (ele.key === subKey) {
          let col = ele.columns
          let sortIndex = col.findIndex(item => item.key === sortField)
          let tempArrLast = col.slice(sortIndex)
          let tempArrFirst = col.slice(0, sortIndex)
          ele.columns = [...tempArrFirst, ...columns, ...tempArrLast]
        }
      })
      this.subKey++
    },
    /**
     * 打开js增强模态框
     * @param href  组件路径或者http地址
     * @param detailData  详情对象
     * @param modalConfig  模态框配置信息
     * @author guochao
     * @date 2022/10/11 9:33
     */
    openHrefCompModal(href, detailData = null, modalConfig) {
      // 解析 href 参数
      let index = href.indexOf('?')
      let path = href
      if (index !== -1) {
        path = href.substring(0, index)
        let paramString = href.substring(index + 1, href.length)
        let paramArray = paramString.split('&')
        let params = {}
        paramArray.forEach(paramObject => {
          let paramItem = paramObject.split('=')
          params[ paramItem[ 0 ] ] = paramItem[ 1 ]
        })
        this.hrefComponent.params = params
      } else {
        this.hrefComponent.params = {}
      }
      // 给模态框组件设置参数
      if (detailData) {
        this.buttonCode = detailData.buttonCode
        this.hrefComponent.params.detailData = detailData
      }
      // 设置模态框参数
      modalConfig && (this.hrefComponent.model = {
        ...this.hrefComponent.model,
        ...modalConfig
      })
      // 引入模态框内展示组件
      this.hrefComponent.is = () => import('@/views/' + (path.startsWith('/')? path.slice(1): path))
      this.hrefComponent.model.visible = true
    },
    // 获取当前子表Ref
    subTableRef(subKey = this.getSubKey()) {
      if (!this.$refs[ subKey ][ 0 ]) return this.$message.warning(`子表名称【${subKey}】未定义`)
      return this.$refs[ subKey ][ 0 ]
    },
    // 禁用整个表单，主表和子表都禁用
    changeAllForm(isDisabled) {
      this.online_form_disabled = isDisabled
    },
    // 隐藏或展示子表列表工具栏
    changeToolbar(subKey = this.getSubKey(), isShow) {
      this.subToolbar[ subKey ] = isShow
    },
    /**
     * 改变主表单项属性参数，可以使主表指定字段disabled
     * @param field  改变表单项的字段code
     * @param attrObj  要增加或修改的表单项参数对象
     * @author guochao
     * @date 2022/10/13 11:39
     */
    changeAttrs(field, attrObj) {
      for (let item of this.rootProperties) {
        if (item.key === field) {
          item.setUiSchema(attrObj)
        }
      }
    },
    // 根据字段获取popup弹框选中数据
    getPopupSelected(field) {
      return this.popupSelected[ field ]
    },
    /******************@原框架方法************************/
    /** 供 js 增强调用：重新执行主表的填值规则  */
    executeMainFillRule() {
      this.$nextTick(() => {
        this.loadMainFieldDefVal(ACTION_TYPES.RELOAD)
      })
    },
    /**
     *  供 js 增强调用：重新执行子表的填值规则
     * @param subKey 子表 key
     * @param event 子表onChange事件传递的 event
     */
    executeSubFillRule(subKey = this.getSubKey(), event) {
      this.$nextTick(() => {
        this.subTabInfo.forEach(subTable => {
          if (subTable.key === subKey) {
            let { row, form, target } = event
            this.loadSubFieldDefVal({ jvt: target, form }, subTable, row, ACTION_TYPES.RELOAD)
          }
        })
      })
    },
    //改变下拉项
    changeOptions(field, options) {
      for (let item of this.rootProperties) {
        if (item.key === field) {
          item.initOptions(options)
        }
      }
    },
    //获取下拉项
    getSelectOptions(field) {
      for (let item of this.rootProperties) {
        if (item.key === field) {
          return item.listSource
        }
      }
    },
    // 清空子表并添加数据
    clearThenAddRows(subKey = this.getSubKey(), rows) {
      this.clearSubRows(subKey)
      this.addSubRows(subKey, rows)
    },
    // 给子表插入数据
    addSubRows(subKey = this.getSubKey(), rows) {
      if (!rows) {
        return false
      }
      if (typeof rows == 'object') {
        //lvdandan --begin-- date:20201117 for:LOWCOD-987 【online】新版行编辑js增强的问题
        this.$refs[ subKey ][ 0 ].addRows(rows, true)
        //lvdandan --end-- date:20201117 for:LOWCOD-987 【online】新版行编辑js增强的问题
      } else {
        this.$message.error('你脑壳瓦钓了,传的什么参数!')
      }
    },
    // 清空子表所有数据
    clearSubRows(subKey = this.getSubKey()) {
      let rows = [...this.$refs[ subKey ][ 0 ].getNewDataWithId(), ...this.subDataSource[ subKey ]]
      if (!rows || rows.length == 0) {
        return false
      }
      let ids = []
      for (let i of rows) {
        ids.push(i.id)
      }
      this.$refs[ subKey ][ 0 ].removeRowsById(ids)
    },
    // 给主表/子表表单设置值
    triggleChangeValues(values, id, target) {
      if (id && target) {
        target.setValues([{
          rowKey: id,
          values: values
        }])
      } else {
        this.form.setFieldsValue(values)
      }
    },
    // 给主表表单单个字段设置值
    triggleChangeValue(field, value) {
      if (!field || !value) return this.$message.warning('triggleChangeValue方法缺少参数')
      this.form.setFieldsValue({
        [ field ]: value
      })
    }
  }
}